import React, { FC, useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { CreateVideoClickTarget } from '../../constants/Bi';
import { PageTabsNames } from '../../constants/PageTabsNames';
import { useTrackCreateVideoClick } from '../../utils/hooks/bi/useTrackCreateVideoClick';
import {
  NotificationMessages,
  useTrackNotificationInteraction,
} from '../../utils/hooks/bi/useTrackNotificationInteraction';
import { useVideoMaker } from '../../utils/hooks/useVideoMaker';
import { Orientations } from '../../utils/hooks/useVideoMaker/videoMaker.types';
import { useVideoMakerTemplates } from '../../utils/hooks/useVideoMakerTemplates';
import { EmptyStateGeneric } from '../common/EmptyStateGeneric';
import { TextButton, WixIcons } from '../common/wixCommon';
import { ReactComponent as NoVideoFilesIcon } from './icons/noItemsIcon.svg';

export const EmptyStateNoVideoFiles: FC = () => {
  const { trackErrorShown } = useTrackNotificationInteraction();

  const { trackVideoMakerCreateVideoClick } = useTrackCreateVideoClick();

  useEffect(() => {
    trackErrorShown({
      errorMessage: NotificationMessages.NoVideoFilesMyVideos,
    });
  }, [trackErrorShown]);

  const { openVideoMaker } = useVideoMaker();

  const { getTemplateData, findTemplateByType } = useVideoMakerTemplates();

  const handleCreateNewVideoClick = useCallback(() => {
    trackVideoMakerCreateVideoClick({
      target: CreateVideoClickTarget.CreateNewVideoEmptyState,
      tabName: PageTabsNames.MyVideos,
    });

    const requiredTemplate = findTemplateByType('create-new');
    const templateData = getTemplateData({
      ...requiredTemplate,
      orientation: Orientations.Landscape,
    });

    openVideoMaker(templateData);
  }, [
    openVideoMaker,
    getTemplateData,
    findTemplateByType,
    trackVideoMakerCreateVideoClick,
  ]);

  return (
    <EmptyStateGeneric
      dataHook="empty-state-no-video-files"
      title={
        <FormattedMessage id="video-maker-home.empty-state.no-files.title" />
      }
      subtitle={
        <FormattedMessage id="video-maker-home.empty-state.no-files.description" />
      }
      image={<NoVideoFilesIcon />}
    >
      <TextButton
        dataHook="empty-state-no-video-files-action-button"
        prefixIcon={<WixIcons.Add />}
        onClick={handleCreateNewVideoClick}
      >
        <FormattedMessage id="video-maker-home.empty-state.no-files.action.link" />
      </TextButton>
    </EmptyStateGeneric>
  );
};
